import { createSelector } from 'reselect';

export const getInfoIsLoading = state => state.info.isLoading;

const getIds = state => state.info.data;
const getResult = state => state.entities.info;
export const getInfo = createSelector(getIds, getResult, (ids, result) => {
  if (ids) {
    return result[ids];
  }

  return null;
});



// WEBPACK FOOTER //
// ./src/redux/selectors/info.js